export default "__VITE_ASSET__CDMceP7e__"